import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/HomepageStatic/CapitalMarketsStatic";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const CapitalMarketsStaticMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="CapitalMarketsStatic">
      <MobileNotice page="CapitalMarketsStatic" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default CapitalMarketsStaticMobile;